
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, List } from '@mui/material';
import DockerDragDrop from './dockerDragDrop';



export default function ZipFileUpload({fileUpload, bannerShow}) {

    const onDrop = files => {
        fileUpload(files);
    };

    const {getRootProps, getInputProps} = useDropzone({maxFiles:1, onDrop, accept: {'application/zip': ['.zip'], 'application/x-zip-compressed': ['.zip']}});


    return(
        <Box>
            <Box {...getRootProps()}>
                <input {...getInputProps()} disabled={bannerShow} />
                <DockerDragDrop />
            </Box>
        </Box>

    )
}